import React from "react";
import ReactDOM from "react-dom";
import IotmateButton from "./IotmateButton";
import "./DialogBox.css";

const DialogBox = ({
  isOpen,
  onClose,
  title,
  children,
  onSave,
  saveLabel = "Save",
  cancelLabel = "Cancel",
  showActions = true,
}) => {
  if (!isOpen) return null;

  // Use React Portal to render dialog at document body level
  // This ensures the dialog appears on top of everything regardless of parent CSS
  return ReactDOM.createPortal(
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="dialog-title">{title}</h2>
        <div className="dialog-body">{children}</div>
        {showActions && (
          <div className="dialog-actions">
            <IotmateButton variant="cancel" onClick={onClose}>
              {cancelLabel}
            </IotmateButton>
            <IotmateButton variant="primary" onClick={onSave}>
              {saveLabel}
            </IotmateButton>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default DialogBox;
